// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aG23","content":"styles_content__3TXtp","tableWrap":"styles_tableWrap__3TC8T"};